import { useLocation, useNavigate } from 'react-router-dom';
import { customRoutes } from '../data/customRoutes';
import { useCallback, useEffect, useMemo } from 'react';
import { useLoginStore } from '../store/useLogin';

type UserRole = 'ROLE_USER' | 'ROLE_ADMIN' | 'ROLE_CS' | 'ROLE_TRACKING' | 'ROLE_JOINED' | 'ROLE_MARKETING';

export const useCustomRoute = () => {
  const { role } = useLoginStore();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const INVALID_URL = useMemo(
    () => ({
      ROLE_USER: '/today-saju/codes',
      ROLE_ADMIN: '/order/fix',
      ROLE_CS: '/order/create',
      ROLE_TRACKING: '/today-saju/codes',
      ROLE_JOINED: '/',
      ROLE_MARKETING: '/today-saju/codes',
    }),
    []
  );

  const findRouteConfig = (path: string) => {
    // 고정된 경로에 대한 단순 매칭
    if (customRoutes[path]) {
      return customRoutes[path];
    }

    // 동적 경로 패턴에 대한 매칭 (예: '/order/list/1' -> '/order/list/:orderId')
    const dynamicRoute = Object.keys(customRoutes).find(routePath => {
      // 동적 경로를 `:param` 형식으로 변환, 숫자만 매칭하도록 변경
      const routeRegex = new RegExp(`^${routePath.replace(/:\w+/g, '[^/]+')}$`);
      return routeRegex.test(path);
    });

    return dynamicRoute ? customRoutes[dynamicRoute] : undefined;
  };

  const routeConfig = findRouteConfig(pathname);

  // 역할 기반 접근 제어
  const isValidRole = useCallback(
    (allowedRoles: UserRole[]) => {
      return allowedRoles.includes(role);
    },
    [role]
  );

  // 유효하지 않은 경로에 대한 리다이렉트 처리
  useEffect(() => {
    if (!routeConfig || !isValidRole(routeConfig.role)) {
      navigate(INVALID_URL[role], { replace: true });
    }
  }, [routeConfig, navigate, INVALID_URL, role, isValidRole]);

  return { routeConfig };
};
